import { ColumnMetadata } from "~/components/DataGrid";
import { AssetColumns } from "~/modules/assets/types";
import { TRAILING_30_DAY_ACTIVE_ADDRESSES_COUNT_COLUMN } from "./ActiveAddresses";
import { ASSET_NAME_AND_TICKER_COLUMN_EXPANDABLE } from "./AssetName";
import { HOLDING_ADDRESS_COUNT_COLUMN } from "./Holders";
import { ISSUER_WITH_LEGAL_IDENTIFIER } from "./Issuer";
import { NET_ASSET_VALUE_COLUMN } from "./NetAssetValue";
import { NETWORKS_COLUMN } from "./Networks";
import { PLATFORM_COLUMN } from "./Platform";
import {
    PRIMARY_MARKET_SUBSCRIPTION_FEE_COLUMN,
    PRIMARY_MARKET_REDEMPTION_FEE_COLUMN,
} from "./PrimaryMarket";
import { LICENSE_OR_REGULATORY_FRAMEWORK } from "./RegulatoryFramework";
import { AssetTableRowData } from "../types";
import { TRADITIONAL_CUSTODIAN_WITH_LEI_OR_CIK } from "./TraditionalCustodian";
import { TRAILING_30_DAY_TRANSFER_COUNT_COLUMN } from "./TransferCount";
import { TRAILING_30_DAY_TRANSFER_VOLUME_COLUMN } from "./TransferVolume";
import { BRIDGED_TOKEN_VALUE_DOLLAR_COLUMN } from "./BridgedTokenValueDollar";
import { UNDERLYING_ASSET_COLUMN } from "./UnderlyingAssets";
import { INCORPORATION_COUNTRY_COLUMN } from "./IncorporationCountry";
import { TRANSPARENCY_COLUMN } from "./Transparency";
import { CONTRACT_ADDRESS_COLUMN } from "./ContractAddress";
import { BRIDGED_TOKEN_VALUE_DOLLAR_SPARKLINE_COLUMN } from "./Sparklines";
import { TOKENIZATION_TYPE_COLUMN } from "./TokenizationType";

// // // //

export const PUBLIC_EQUITY_TABLE_COLUMNS: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
>[] = [
    ASSET_NAME_AND_TICKER_COLUMN_EXPANDABLE,
    { ...PLATFORM_COLUMN, sortsOn: AssetColumns.protocolNames },
    { ...NETWORKS_COLUMN, sortsOn: AssetColumns.networkNames },
    { ...BRIDGED_TOKEN_VALUE_DOLLAR_COLUMN, label: "Total Value" },
    BRIDGED_TOKEN_VALUE_DOLLAR_SPARKLINE_COLUMN,
    TOKENIZATION_TYPE_COLUMN,
    UNDERLYING_ASSET_COLUMN,
    NET_ASSET_VALUE_COLUMN,
    HOLDING_ADDRESS_COUNT_COLUMN,
    TRAILING_30_DAY_TRANSFER_VOLUME_COLUMN,
    ISSUER_WITH_LEGAL_IDENTIFIER,
    INCORPORATION_COUNTRY_COLUMN,
    LICENSE_OR_REGULATORY_FRAMEWORK,
    TRADITIONAL_CUSTODIAN_WITH_LEI_OR_CIK,
    TRANSPARENCY_COLUMN,
    PRIMARY_MARKET_SUBSCRIPTION_FEE_COLUMN,
    PRIMARY_MARKET_REDEMPTION_FEE_COLUMN,
    TRAILING_30_DAY_TRANSFER_COUNT_COLUMN,
    TRAILING_30_DAY_ACTIVE_ADDRESSES_COUNT_COLUMN,
    CONTRACT_ADDRESS_COLUMN,
];
